import style from "./AboutUsAndLegal.module.scss";
import AccountHeader from "./AccountHeader";
import { QuickLinkItem } from "../QuickLink";

const AboutUsAndLegal = () => {
  const icon = "Open";
  const aboutUsAndLegalItems = [
    {
      description: "Conditions of use and disclaimer",

      link: "https://www.tg.org.au/condition-use/",
    },
    {
      description: "Privacy policy",
      link: "https://www.tg.org.au/privacy-policy/",
    },
    {
      description: "Licence agreement",
      link: "https://www.tg.org.au/news/",
    },
    {
      description: "Copyright permission",
      link: "https://www.tg.org.au/copyright-permissions/",
    },
    {
      description: "Support and FAQ",
      link: "https://www.tg.org.au/about-us/faqs/",
    },
  ];

  return (
    <div className={style.container}>
      <AccountHeader headername="About Us & Legal" />
      <div className={style.legalMenuList}>
        {aboutUsAndLegalItems.map(({ description, link }, i) => {
          return (
            <QuickLinkItem
              rightIcon={icon}
              title={description}
              key={`link-${i}`}
              link={link}
              className="centered"
              documents={true}
            />
          );
        })}
      </div>
    </div>
  );
};

export default AboutUsAndLegal;
